import moment from 'moment.lib';
// eslint-disable-next-line no-restricted-imports
import jQuery from 'jquery.lib';
import { initialize } from './i18n';

window.jQuery = window.jQuery || jQuery;
window.moment = window.moment || moment;

initialize();
